import React, { useEffect } from "react";
import cx from "classnames";
import styles from "./switchLayout.module.scss";
import Slider from "../../../../components/slider";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../redux/store";
import { useNavigate } from "react-router-dom";
import { fetchHubLayout } from "../../../../redux/actions/hub";
import Button from "src/components/button";
import { useHubAdoption } from "src/redux/actions/adoption/hub";
import _ from "lodash";

interface SwitchLayoutProps {
  show: boolean;
  onClose: () => void;
}

const SwitchLayout: React.FC<SwitchLayoutProps> = ({ show, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const layouts = useSelector((state: RootState) => state.hub?.layouts);
  const activeLayout = useSelector((state: RootState) => state.hub?.item);

  const [selectedLayout, setSelectedLayout] = React.useState<string>(activeLayout.id);

  const { trackHubSwitchScreenView, trackHubSwitchedEvent } = useHubAdoption();

  useEffect(() => {
    if(show){
      trackHubSwitchScreenView();
    }
  },[show])

  useEffect(() => {
    setSelectedLayout(activeLayout.id);
  },[activeLayout])
  
  const handleClose = () => {
    onClose();
  };

  const handleChangeLayout = () => {
    navigate(`/hub/layout/${selectedLayout}`);
    const layoutName = _.get(_.find(layouts, { id: selectedLayout }), "name"); 
    trackHubSwitchedEvent(layoutName);
    localStorage.setItem("hubLayout", selectedLayout);
    dispatch(fetchHubLayout({ id: selectedLayout }));
    handleClose();
  }

  const handleSelectLayout = (id: string) => {
    setSelectedLayout(id);
  }

  const handleCancel = () => {
    setSelectedLayout(activeLayout.id);
    handleClose();
  }

  return (
    <Slider.Dialog width={"380"} show={show} onClose={handleClose}>
      <Slider.Header
        title={<>hub roulette, anyone?</>}
        message="Select your content playground."
      />
      <Slider.Body>
        <span className={styles.layoutNames}>
          {renderLayoutNames(
            layouts,
            selectedLayout,
            handleSelectLayout
          )}
        </span>
      </Slider.Body>
      <Slider.Actions>
        <Button variant="primary" text="Done" icon="paperflite-tick" onClick={handleChangeLayout}></Button>
        <Button variant="secondary" text="Cancel" onClick={handleCancel}></Button>
      </Slider.Actions>
    </Slider.Dialog>
  );
};

function renderLayoutNames(
  layouts: any,
  selectedLayout: string,
  handleSelectLayout: (id: string) => void
) {
  const names = layouts.map((layout: any, index: number) => (
    <div className={styles.layoutNameRow} key={layout.id}>
      <span
        className={cx(styles.layoutNumber, {
          [styles.activeLayoutNumber]: layout.id === selectedLayout,
        })}
      >
        {index + 1}
      </span>
      <span
        className={cx(
          { [styles.activeLayout]: layout.id === selectedLayout },
          styles.layoutName,
        )}
        onClick={() => handleSelectLayout(layout.id)}
      >
        {_.get(layout, "name", "")}
      </span>
    </div>
  ));

  return <div>{names}</div>;
}

export { SwitchLayout };
